/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  window.PXUTheme.jsAjaxCart = {
    init: function ($section) {

      // console.log('jsAjaxCart init', $section)

      // Add settings from schema to current object
      window.PXUTheme.jsAjaxCart = $.extend(this, window.PXUTheme.getSectionData($section));

      if (isScreenSizeLarge() || this.cart_action == 'drawer') {
        this.initializeAjaxCart();
      } else {
        this.initializeAjaxCartOnMobile();
      }

      if (this.cart_action == 'drawer') {

        this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

        $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
          e.preventDefault();
          window.PXUTheme.jsAjaxCart.showDrawer();

          return false;
        });

        $(document).on('click', '[data-ajax-cart-toggle-gift-wrap]', function (e) {
          window.PXUTheme.jsAjaxCart.toggleGiftWrappingOption(e);
        })

        $(document).on('click', '[data-recommended-product-add-to-cart]', function (e) {
          window.PXUTheme.jsAjaxCart.addRecommendedProductToCart(e);
        })

      } else if (this.cart_action == 'mini_cart') {
        this.showMiniCartOnHover();
      }

      $(document).on('click', '.ajax-submit', function (e) {
        e.preventDefault();
        const $addToCartForm = $(this).closest('form');
        window.PXUTheme.jsAjaxCart.addToCart($addToCartForm);

        return false;
      });

      $(document).on('click', '[data-ajax-cart-delete]', function (e) {
        e.preventDefault();
        const lineID = $(this).parents('[data-line-item]').data('line-item');
        const monogramLineID = $(this).data('monogram-item-key');
        const lineKey = $(this).data('cart-item-key');

        if (monogramLineID) {
          window.PXUTheme.jsAjaxCart.removeItemWithMonogramFromCart(lineID, monogramLineID, lineKey);
        } else {
          window.PXUTheme.jsAjaxCart.removeFromCart(lineID);
        }

        return false;
      });

      $(document).on('click', '[data-ajax-cart-close]', function (e) {
        e.preventDefault();
        window.PXUTheme.jsAjaxCart.hideDrawer();
        window.PXUTheme.jsAjaxCart.hideMiniCart();

        return false;
      });

    },
    showMiniCartOnHover: function () {
      const $el = $('[data-ajax-cart-trigger]');

      $el.hover(function () {
        if (window.PXUTheme.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
          $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
        } else {
          $el.addClass('show-mini-cart');
        }
      }, function () {
        $el.removeClass('show-mini-cart');
      });
    },
    hideMiniCart: function () {
      if (this.cart_action != 'mini_cart') return false;
      const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
      $el.removeClass('show-mini-cart');
    },
    toggleMiniCart: function () {
      const $el = $('.mobile-header [data-ajax-cart-trigger]');

      // Removes url to the cart page so user is not redirected
      $el.attr('href', '#');

      $el.off('touchstart').on('touchstart', function (e) {
        // If user clicks inside the element, do nothing
        if (e.target.closest('[data-ajax-cart-mini_cart]')) {
          return;
        }

        // Loads content into ajaxCart container for mobile header
        window.PXUTheme.jsAjaxCart.initializeAjaxCartOnMobile();

        // If user clicks outside the element, toggle the mini cart
        $el.toggleClass('show-mini-cart');
      });
    },
    toggleGiftWrappingOption: function (e) {
      if (this.cart_action != 'drawer') return false;
      var $giftWrapProductId = $('[data-gift-wrap-product]').val();
      if (e.target.checked) {
        window.PXUTheme.jsAjaxCart.addItemToCart($giftWrapProductId);
      } else {
        window.PXUTheme.jsAjaxCart.removeItemFromCart($giftWrapProductId);
      }
    },

    addRecommendedProductToCart: function (e) {
      if (this.cart_action != 'drawer') return false;
      e.preventDefault();
      var $recommendedProductId = $('[data-recommended-product]').val();
      window.PXUTheme.jsAjaxCart.addItemToCart($recommendedProductId);
    },
    showDrawer: function () {
      if (this.cart_action != 'drawer') return false;
      this.ajaxCartDrawer.addClass('is-visible');
      $('.ajax-cart__overlay').addClass('is-visible');
    },
    hideDrawer: function () {
      if (this.cart_action != 'drawer') return false;
      this.ajaxCartDrawer.removeClass('is-visible');
      $('.ajax-cart__overlay').removeClass('is-visible');
    },
    hideLoading: function () {
      this.ajaxCartDrawer.removeClass('is-loading');

      if (typeof window.PXUTheme.jsCart !== 'undefined') {
        window.PXUTheme.jsCart.hideLoading();
      }
    },
    showLoading: function () {
      this.ajaxCartDrawer.addClass('is-loading');

      if (typeof window.PXUTheme.jsCart !== 'undefined') {
        window.PXUTheme.jsCart.showLoading();
      }
    },
    addItemToCart: function (lineID, callback) {
      // console.log('adding', lineID);
      window.PXUTheme.jsAjaxCart.showLoading();
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          items: [
            {
              id: lineID,
              quantity: 1
            }
          ]
        },
        dataType: 'json',
        success: function (cart) {
          window.PXUTheme.jsAjaxCart.updateView();
          window.PXUTheme.jsAjaxCart.hideLoading();
        },
        error: function (XMLHttpRequest, textStatus) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
        }
      });
    },
    removeItemFromCart: function (lineID, callback) {
      window.PXUTheme.jsAjaxCart.showLoading();
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          id: lineID,
          quantity: 0
        },
        dataType: 'json',
        success: function (cart) {
          window.PXUTheme.jsAjaxCart.updateView();
          window.PXUTheme.jsAjaxCart.hideLoading();
        },
        error: function (XMLHttpRequest, textStatus) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
        }
      });
    },
    removeFromCart: function (lineID, callback) {
      window.PXUTheme.jsAjaxCart.showLoading();
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=0&line=' + lineID,
        dataType: 'json',
        success: function (cart) {
          window.PXUTheme.jsAjaxCart.updateView();
        },
        error: function (XMLHttpRequest, textStatus) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;

        }
      });
    },
    removeItemWithMonogramFromCart: function (lineID, monogramLineID, lineKey) {
      window.PXUTheme.jsAjaxCart.showLoading();

      let updates = {};
      updates[lineKey] = 0;
      updates[monogramLineID] = 0;

      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
          updates: updates
        },
        dataType: 'json',
        success: function (cart) {
          window.PXUTheme.jsAjaxCart.updateView();
        },
        error: function (XMLHttpRequest, textStatus) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
        }
      });
    },
    checkProductsInCart: function () {
      console.log('checkProductsInCart');

      fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
      }).then(response => response.json()).then(data => {
        if (data) {
          data.items.forEach(item => {
            if (item.properties && item.properties['_bundleKey']) {
              let bundleKey = item.properties['_bundleKey'];

            // there need to be two products with _bundleKey
            // there can be products with no _bundleKey
            // there cannot be single product with _bundleKey

            if (bundleKey) {
              let bundleItems = data.items.filter(item => {
                if (item.properties && item.properties['_bundleKey']) {
                  return item.properties['_bundleKey'] === bundleKey;
                }
              });

              if (bundleItems.length === 1) {
                // remove orphaned product from cart
                fetch('/cart/change.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    id: item.key,
                    quantity: 0
                  })
                }).then(response => response.json()).then(data => {
                  console.log('removed', data);
                  window.PXUTheme.jsAjaxCart.updateView();
                });
              }
            }
            }
          });

          data.items.forEach(item => {
            // find products with product_id 5145863717000 that have no _bundleKey and remove them
            if (item.product_id === 5145863717000 && !item.properties['_bundleKey']) {
              fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  id: item.key,
                  quantity: 0
                })
              }).then(response => response.json()).then(data => {
                console.log('removed', data);
                window.PXUTheme.jsAjaxCart.updateView();
              });
            }
          });
        }
      });

    },
    initializeAjaxCart: function () {

      window.PXUTheme.asyncView.load(
        window.PXUTheme.routes.cart_url, // template name
        'ajax', // view name (suffix)
      )
        .done(({ html, options }) => {

          $('[data-ajax-cart-content]').html(html.content);

          // Converting the currencies
          if (window.PXUTheme.currencyConverter) {
            window.PXUTheme.currencyConverter.convertCurrencies();
          }

          this.checkProductsInCart();

        })
        .fail(() => {
          // some error handling
        });
    },
    initializeAjaxCartOnMobile: function () {

      this.toggleMiniCart();

      window.PXUTheme.asyncView.load(
        window.PXUTheme.routes.cart_url, // template name
        'ajax', // view name (suffix)
      )
        .done(({ html, options }) => {

          $('.mobile-header [data-ajax-cart-content]').html(html.content);

          this.checkProductsInCart();

        })
        .fail(() => {
          // some error handling
        });
    },
    addToCart: function ($addToCartForm) {
      const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');

      $addToCartForm.removeClass('shopify-product-form--unselected-error');


      if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
        const cartWarning = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;

        $('.warning').remove();

        $addToCartForm
          .addClass('shopify-product-form--unselected-error')
          .find('.cart-warning')
          .html(cartWarning);

        $addToCartBtn
          .removeAttr('disabled')
          .removeClass('disabled');

        $addToCartBtn.find('.icon')
          .removeClass('zoomOut')
          .addClass('zoomIn');

        $addToCartBtn
          .find('span:not(.icon)')
          .text($addToCartBtn.data('label'))
          .removeClass('zoomOut')
          .addClass('zoomIn');
      } else {
        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: $addToCartForm.serialize(),
          beforeSend: function () {
            $addToCartBtn
              .attr('disabled', 'disabled')
              .addClass('disabled');

            $addToCartBtn.find('span')
              .removeClass("fadeInDown")
              .addClass('animated zoomOut');
          },
          success: function (product) {

            let $el = $('[data-ajax-cart-trigger]');

            $addToCartBtn
              .find('.checkmark')
              .addClass('checkmark-active');

            function addedToCart() {

              if (!isScreenSizeLarge()) {
                $el = $('.mobile-header [data-ajax-cart-trigger]');
                window.PXUTheme.scrollToTop($el);
              } else {
                $el = $('[data-ajax-cart-trigger]');
              }

              $el.addClass('show-mini-cart');

              $addToCartBtn.find('span')
                .removeClass('fadeInDown');
            }

            window.setTimeout(function () {
              $addToCartBtn
                .removeAttr('disabled')
                .removeClass('disabled');

              $addToCartBtn.find('.checkmark')
                .removeClass('checkmark-active');

              $addToCartBtn.find('.text, .icon')
                .removeClass('zoomOut')
                .addClass('fadeInDown');

              $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);

            }, 1000);

            window.PXUTheme.jsAjaxCart.showDrawer();
            window.PXUTheme.jsAjaxCart.updateView();

            if (window.PXUTheme.jsCart) {
              $.ajax({
                dataType: "json",
                async: false,
                cache: false,
                dataType: 'html',
                url: "/cart",
                success: function (html) {
                  const cartForm = $(html).find('.cart__form');
                  $('.cart__form').replaceWith(cartForm);

                }
              });
            }

          },
          error: function (XMLHttpRequest) {
            let response = eval('(' + XMLHttpRequest.responseText + ')');
            response = response.description;

            const cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;

            $('.warning').remove();

            $addToCartForm
              .find('.cart-warning')
              .html(cartWarning);

            $addToCartBtn
              .removeAttr('disabled')
              .removeClass('disabled');

            $addToCartBtn.find('.icon')
              .removeClass('zoomOut')
              .addClass('zoomIn');

            $addToCartBtn
              .find('span:not(.icon)')
              .text($addToCartBtn.data('label'))
              .removeClass('zoomOut')
              .addClass('zoomIn');
          }
        });
      }
    },
    updateView: function () {
      window.PXUTheme.jsAjaxCart.showLoading();
      window.PXUTheme.asyncView.load(
        window.PXUTheme.routes.cart_url, // template name
        'ajax', // view name (suffix)
      )
        .done(({ html, options }) => {

          if (options.item_count > 0) {
            const itemList = $(html.content).find('.ajax-cart__list');
            const cartDetails = $(html.content).find('.ajax-cart__details-wrapper');

            $('.ajax-cart__list').replaceWith(itemList);
            $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
            $('.ajax-cart__empty-cart-message').addClass('is-hidden');
            $('.ajax-cart__form').removeClass('is-hidden');
            $('[data-ajax-cart-trigger]').addClass('has-cart-count');
            $('[data-bind="itemCount"]').text(options.item_count);

          } else {
            $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
            $('.ajax-cart__form').addClass('is-hidden');
            $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
            $('[data-bind="itemCount"]').text('0');
          }

          if (window.PXUTheme.currencyConverter) {
            window.PXUTheme.currencyConverter.convertCurrencies();
          }
          window.PXUTheme.jsAjaxCart.hideLoading();
        })
        .fail(() => {
          // some error handling
        });
    },
    unload: function ($section) {

      // Clear event listeners in theme editor
      $('.ajax-submit').off();
      $('[data-ajax-cart-delete]').off();
    }
  }

  /******/
})()
  ;